import React, { useState } from "react";
import style from "./Navbar.module.css";
import { Link } from "react-router-dom";

function Navbar({ setShowLogin }) {
  return (
    <div className={style.navbar}>
      <div className={style.logo}>
        <div className={style.logotxt}>
          {/* <img className={style.logoimg} src={skillhub} alt="" /> */}
          <Link to="/">
            {" "}
            <p className="text-[#1A3168]">
              <span className="text-[#FFF856]">ED</span>flix.
            </p>
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-center gap-8">
        <button
          className={style.login}
          onClick={() => {
            setShowLogin(true);
          }}
        >
          Login
        </button>

        <button className={style.Admin}>
          <Link to="/Admin_Dashboard">Admin</Link>
        </button>
      </div>
    </div>
  );
}

export default Navbar;
